var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient0, _linearGradient1, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuilding = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 841.89 373.56",
  ref: ref,
  "aria-labelledby": titleId
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  x: -0.92,
  y: -1.67,
  width: 841.83,
  height: 373.56,
  style: {
    fill: "none"
  }
})), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 354.03,
  y1: 282.9,
  x2: 454.28,
  y2: 282.9,
  gradientTransform: "matrix(1, 0.03, -0.03, 1, 7.3, -9.91)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00d38d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
}))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 382.62,
  y1: 290.7,
  x2: 392.36,
  y2: 280.96,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#linear-gradient"
})), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 427.36,
  y1: 308.47,
  x2: 437.1,
  y2: 298.73,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#linear-gradient"
})), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: 851.81,
  y1: 285.83,
  x2: 754.39,
  y2: 285.83,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f4b01a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
}))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-6",
  x1: 769.59,
  y1: 290.34,
  x2: 779.02,
  y2: 280.91,
  xlinkHref: "#linear-gradient-4"
})), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-7",
  x1: 790.77,
  y1: 302.89,
  x2: 801.31,
  y2: 302.89,
  xlinkHref: "#linear-gradient-4"
})), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-8",
  x1: 165.93,
  y1: 279.91,
  x2: 70.5,
  y2: 279.91,
  xlinkHref: "#linear-gradient-4"
})), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-9",
  x1: 107.09,
  y1: 286,
  x2: 115.44,
  y2: 277.65,
  xlinkHref: "#linear-gradient-4"
})), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-10",
  x1: 144.19,
  y1: 286,
  x2: 152.54,
  y2: 277.65,
  xlinkHref: "#linear-gradient-4"
})), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-11",
  x1: 126.6,
  y1: 270.5,
  x2: 134.95,
  y2: 262.15,
  xlinkHref: "#linear-gradient-4"
})), _linearGradient1 || (_linearGradient1 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-12",
  x1: 193.22,
  y1: 144.91,
  x2: 209.18,
  y2: 144.91,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ac41d8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
}))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-13",
  x1: 1492.55,
  y1: 885.72,
  x2: 1505.88,
  y2: 885.72,
  gradientTransform: "translate(-1053.2 1328.22) rotate(-73.55)",
  xlinkHref: "#linear-gradient-12"
})), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-14",
  x1: 390,
  y1: 145.3,
  x2: 416.21,
  y2: 145.3,
  gradientTransform: "matrix(-1, 0, 0, 1, 615.63, 0)",
  xlinkHref: "#linear-gradient-12"
})), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-15",
  x1: 413.44,
  y1: -751.95,
  x2: 435.07,
  y2: -751.95,
  gradientTransform: "matrix(-0.87, -0.49, -0.49, 0.87, 194.34, 1053.3)",
  xlinkHref: "#linear-gradient"
})), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-16",
  x1: 436.91,
  y1: -738.81,
  x2: 458.54,
  y2: -738.81,
  gradientTransform: "translate(206.53 1053.3) rotate(-29.25)",
  xlinkHref: "#linear-gradient"
})), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-17",
  x1: 188.84,
  y1: 205.44,
  x2: 239,
  y2: 205.44,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#linear-gradient"
})), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-18",
  x1: 253.14,
  y1: 209.11,
  x2: 295.06,
  y2: 209.11,
  gradientTransform: "matrix(-0.99, -0.11, -0.11, 0.99, 577.28, 37.71)",
  xlinkHref: "#linear-gradient-4"
})), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-19",
  x1: 3291.85,
  y1: 166.4,
  x2: 3314.33,
  y2: 166.4,
  gradientTransform: "translate(-3016.56 155.11) rotate(-2.05)",
  xlinkHref: "#linear-gradient-4"
})), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-20",
  x1: 1348.15,
  y1: 959.54,
  x2: 1362.27,
  y2: 959.54,
  gradientTransform: "translate(-934.41 1441.94) rotate(-79.08)",
  xlinkHref: "#linear-gradient-12"
})), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-21",
  x1: 342.86,
  y1: 298.9,
  x2: 373.96,
  y2: 298.9,
  gradientTransform: "matrix(-1, 0, 0, 1, 615.63, 0)",
  xlinkHref: "#linear-gradient-12"
})), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-22",
  x1: 235.32,
  y1: 297.03,
  x2: 251.83,
  y2: 297.03,
  xlinkHref: "#linear-gradient-12"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M441.54,320.12c-2.16-2.6-2.71-6.18-2.65-9.56a21.14,21.14,0,0,1,1.44-7.79,13.54,13.54,0,0,1,3.13-4.65.55.55,0,0,1,.89.61,24.06,24.06,0,0,0-2.07,8.4,13.51,13.51,0,0,0,3.49,10.15,24.41,24.41,0,0,1,12.4-1c3,.53,6,1.66,9.06,1.83,3.41.19,6.76-.81,10-1.89l3.69-5.69a7.75,7.75,0,0,1,4.91-3.4l1-.2a7,7,0,0,1,5.63,1.2c1.8,1.44,2.53,3.85,2.77,6.14L502,318c.34,0,.13.7,0,1a4.13,4.13,0,0,1-.71.74c-.35.35-.57.81-.92,1.15a3.88,3.88,0,0,1-3.38.67,7.5,7.5,0,0,0-3.55-.08,5,5,0,0,0-1.75,1.22,14.58,14.58,0,0,0-2.51,3.32c-1.18,2.09-2.1,3.49-4.43,4.48a15.11,15.11,0,0,0-3.9,2,9.85,9.85,0,0,0-2.17,2.93,69,69,0,0,0-3.86,9.07c-.19.51.18.47,0,.92a1.56,1.56,0,0,1-.94.82,4.57,4.57,0,0,1-1.74.37,1.69,1.69,0,0,1-1.21-.53,2.56,2.56,0,0,1-.24-2.24c.2-.92.48-.85.84-1.72l2.23-8.34a65,65,0,0,1-20.47-1.6c-.67,2.71-3,4.61-4.71,6.84a26.5,26.5,0,0,0-3.58,7.25c-.41,1.14-1.94.76-3,.16a.9.9,0,0,1-.42-.42,1.16,1.16,0,0,1,.11-.81,9.12,9.12,0,0,0,.61-3,17.9,17.9,0,0,0-.94-6.49,27.54,27.54,0,0,1-1.59-7.86A13.94,13.94,0,0,1,441.54,320.12Z",
  style: {
    fill: "none"
  }
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-3"
}, /*#__PURE__*/React.createElement("path", {
  d: "M359.82,263.05l10.85,34.57L357.1,330.15l9.47,5.87,17.5-32.52a11.38,11.38,0,0,0,1.15-7.57l-2.78-14.18",
  style: {
    fill: "none"
  }
})), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-23",
  x1: 2984.1,
  y1: 243.35,
  x2: 3008.25,
  y2: 243.35,
  gradientTransform: "translate(-2594.11 -146.68) rotate(2.79)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ee8322"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
}))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-24",
  x1: 3010.17,
  y1: 238.55,
  x2: 3028.87,
  y2: 238.55,
  gradientTransform: "matrix(0.8, -0.6, 0.6, 0.8, -2188.61, 1858.51)",
  xlinkHref: "#linear-gradient-23"
})), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-25",
  x1: 553.34,
  y1: 297.52,
  x2: 700.88,
  y2: 297.52,
  xlinkHref: "#linear-gradient-4"
})), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-26",
  x1: 634.28,
  y1: 289.83,
  x2: 673.43,
  y2: 289.83,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#linear-gradient"
})), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-27",
  x1: 635.62,
  y1: 314.01,
  x2: 672.04,
  y2: 314.01,
  xlinkHref: "#linear-gradient-4"
})), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-28",
  x1: 26.64,
  y1: -872.93,
  x2: 39.22,
  y2: -872.93,
  gradientTransform: "matrix(-1, -0.07, -0.07, 1, 554.02, 1154.1)",
  xlinkHref: "#linear-gradient-12"
})), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-29",
  x1: 723.56,
  y1: -477.01,
  x2: 736.14,
  y2: -477.01,
  gradientTransform: "translate(206.53 1053.3) rotate(-29.25)",
  xlinkHref: "#linear-gradient-12"
})), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-30",
  x1: 582.73,
  y1: 289.53,
  x2: 611.91,
  y2: 289.53,
  xlinkHref: "#linear-gradient-12"
})), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-31",
  x1: 41.56,
  y1: 241.51,
  x2: 58.75,
  y2: 241.51,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#linear-gradient"
}))), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "LOGIN_MRV_VETOR") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  style: {
    isolation: "isolate"
  }
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M187.49,276.87l-1.92-133.64a4.2,4.2,0,0,0-4.2-4.19h-33a10.9,10.9,0,0,0-6.59,2.22c-5,3.85-15.31,12.76-20.56,17.35a9.55,9.55,0,0,0-3.25,7.17l2,117.12",
  style: {
    fill: "#d7d8d6",
    opacity: 0.18
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M243.93,282l1.88-130.85a4.11,4.11,0,0,1,4.11-4.11h32.36a10.64,10.64,0,0,1,6.45,2.17c4.94,3.77,15,12.49,20.13,17a9.31,9.31,0,0,1,3.19,7l-2,114.69",
  style: {
    fill: "#d7d8d6",
    opacity: 0.18
  }
}), /*#__PURE__*/React.createElement("g", {
  style: {
    clipPath: "url(#clip-path)"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M825.21,331.54l-.51-146.09c0-3.87-4.24-6.87-9-6.37l-39.25,4c-4,.41-7,3.14-7,6.37l1.71,140",
  style: {
    fill: "#d7d8d6",
    opacity: 0.18
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M584.92,387.56l.46-132.44c0-3.52,3.85-6.23,8.2-5.78L629.16,253c3.63.38,6.34,2.85,6.34,5.78l-1.55,127",
  style: {
    fill: "#d7d8d6",
    opacity: 0.18
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M398.21,300.54l-.51-146.09c0-3.87-4.24-6.87-9-6.37l-39.25,4c-4,.41-7,3.14-7,6.37l1.71,140",
  style: {
    fill: "#d7d8d6",
    opacity: 0.18
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.21,284.54,96.7,138.45c0-3.87-4.24-6.87-9-6.37l-39.25,4c-4,.41-7,3.14-7,6.37l1.71,140",
  style: {
    fill: "#d7d8d6",
    opacity: 0.18
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M256,338.69v-93.2a8.47,8.47,0,0,0-9.55-8.4l-41.47,5.34a8.48,8.48,0,0,0-7.39,8.4v82.92",
  style: {
    fill: "#d7d8d6",
    opacity: 0.35000000000000003
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M389.86,277.45v-82.2a7.48,7.48,0,0,1,8.43-7.41l36.57,4.72a7.47,7.47,0,0,1,6.52,7.4V273.1",
  style: {
    fill: "#d7d8d6",
    opacity: 0.35000000000000003
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.49,328.56,63.57,194.93a4.2,4.2,0,0,0-4.2-4.2h-33A10.9,10.9,0,0,0,19.74,193c-5,3.85-15.31,12.76-20.56,17.35a9.55,9.55,0,0,0-3.25,7.17l2,117.13",
  style: {
    fill: "#d7d8d6",
    opacity: 0.35000000000000003
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 27.68,
  y: 205.81,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 37.32,
  y: 205.81,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 46.78,
  y: 205.81,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 27.77,
  y: 216.43,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 37.4,
  y: 216.43,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 46.87,
  y: 216.43,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 27.86,
  y: 227.05,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 37.49,
  y: 227.05,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 46.95,
  y: 227.05,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 27.94,
  y: 237.66,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 17.71,
  y: 216.43,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 17.79,
  y: 227.05,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 17.88,
  y: 237.66,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 37.58,
  y: 237.66,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 47.04,
  y: 237.66,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M719,332.18V252.29a8.52,8.52,0,0,0-9.61-8.45l-41.73,5.37a8.53,8.53,0,0,0-7.43,8.46V352.2",
  style: {
    fill: "#d7d8d6",
    opacity: 0.35000000000000003
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 678.2,
  y: 255.59,
  width: 4.79,
  height: 4.79,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 678.2,
  y: 263.48,
  width: 4.79,
  height: 4.79,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 678.2,
  y: 271.38,
  width: 4.79,
  height: 4.79,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 678.2,
  y: 279.27,
  width: 4.79,
  height: 4.79,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 686.2,
  y: 255.59,
  width: 4.79,
  height: 4.79,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 686.2,
  y: 263.48,
  width: 4.79,
  height: 4.79,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 686.2,
  y: 271.38,
  width: 4.79,
  height: 4.79,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 686.2,
  y: 279.27,
  width: 4.79,
  height: 4.79,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 694.2,
  y: 255.59,
  width: 4.79,
  height: 4.79,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 694.2,
  y: 263.48,
  width: 4.79,
  height: 4.79,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 694.2,
  y: 271.38,
  width: 4.79,
  height: 4.79,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 694.2,
  y: 279.27,
  width: 4.79,
  height: 4.79,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 702.2,
  y: 255.53,
  width: 4.79,
  height: 4.79,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 702.2,
  y: 263.42,
  width: 4.79,
  height: 4.79,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 702.2,
  y: 271.31,
  width: 4.79,
  height: 4.79,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 702.2,
  y: 279.2,
  width: 4.79,
  height: 4.79,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M125,328.53l3.22-110.39a4.2,4.2,0,0,1,4.2-4.2h33a10.85,10.85,0,0,1,6.59,2.23c5,3.84,15.3,12.75,20.56,17.34a9.56,9.56,0,0,1,3.25,7.17l-.65,90.25",
  style: {
    fill: "#d7d8d6",
    opacity: 0.35000000000000003
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 158.57,
  y: 229.03,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  transform: "translate(322.67 463.59) rotate(-180)",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 148.93,
  y: 229.03,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  transform: "translate(303.4 463.59) rotate(-180)",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 139.47,
  y: 229.03,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  transform: "translate(284.48 463.59) rotate(-180)",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 158.48,
  y: 239.64,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  transform: "translate(322.5 484.82) rotate(-180)",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 148.85,
  y: 239.64,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  transform: "translate(303.23 484.82) rotate(-180)",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 139.38,
  y: 239.64,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  transform: "translate(284.3 484.82) rotate(-180)",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 158.39,
  y: 250.26,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  transform: "translate(322.33 506.05) rotate(-180)",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 148.76,
  y: 250.26,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  transform: "translate(303.06 506.05) rotate(-180)",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 139.3,
  y: 250.26,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  transform: "translate(284.13 506.05) rotate(-180)",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 158.31,
  y: 260.87,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  transform: "translate(322.15 527.29) rotate(-180)",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 168.54,
  y: 239.64,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  transform: "translate(342.63 484.82) rotate(-180)",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 168.46,
  y: 250.26,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  transform: "translate(342.45 506.05) rotate(-180)",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 168.37,
  y: 260.87,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  transform: "translate(342.28 527.29) rotate(-180)",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 148.67,
  y: 260.87,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  transform: "translate(302.88 527.29) rotate(-180)",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 139.21,
  y: 260.87,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  transform: "translate(283.96 527.29) rotate(-180)",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M855.78,306.17l-1.92-93.64a4.2,4.2,0,0,0-4.2-4.2h-33a10.85,10.85,0,0,0-6.59,2.23c-5,3.85-15.31,12.76-20.56,17.35a9.55,9.55,0,0,0-3.25,7.17l2,77.12",
  style: {
    fill: "#d7d8d6",
    opacity: 0.7000000000000001
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 817.97,
  y: 223.42,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 827.61,
  y: 223.42,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 837.07,
  y: 223.42,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 818.06,
  y: 234.04,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 827.69,
  y: 234.04,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 837.16,
  y: 234.04,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 818.15,
  y: 244.65,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 827.78,
  y: 244.65,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 837.24,
  y: 244.65,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 818.23,
  y: 255.27,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 808,
  y: 234.04,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 808.08,
  y: 244.65,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 808.17,
  y: 255.27,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 827.87,
  y: 255.27,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 837.33,
  y: 255.27,
  width: 5.54,
  height: 5.54,
  rx: 0.93,
  ry: 0.93,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M368.64,321.48v-93.2a9.94,9.94,0,0,0-11.21-9.86l-48.69,6.27a9.94,9.94,0,0,0-8.67,9.86V344.84",
  style: {
    fill: "#d7d8d6",
    opacity: 0.35000000000000003
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 317.56,
  y: 233.3,
  width: 5.59,
  height: 5.59,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 317.56,
  y: 242.51,
  width: 5.59,
  height: 5.59,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 317.56,
  y: 251.71,
  width: 5.59,
  height: 5.59,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 317.56,
  y: 260.92,
  width: 5.59,
  height: 5.59,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 326.9,
  y: 233.3,
  width: 5.59,
  height: 5.59,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 326.9,
  y: 242.51,
  width: 5.59,
  height: 5.59,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 326.9,
  y: 251.71,
  width: 5.59,
  height: 5.59,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 326.9,
  y: 260.92,
  width: 5.59,
  height: 5.59,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 336.23,
  y: 233.3,
  width: 5.59,
  height: 5.59,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 336.23,
  y: 242.51,
  width: 5.59,
  height: 5.59,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 336.23,
  y: 251.71,
  width: 5.59,
  height: 5.59,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 336.23,
  y: 260.92,
  width: 5.59,
  height: 5.59,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 345.56,
  y: 233.22,
  width: 5.59,
  height: 5.59,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 345.56,
  y: 242.43,
  width: 5.59,
  height: 5.59,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 345.56,
  y: 251.64,
  width: 5.59,
  height: 5.59,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 345.56,
  y: 260.84,
  width: 5.59,
  height: 5.59,
  rx: 0.8,
  ry: 0.8,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M521.42,334.26V250.51a4.76,4.76,0,0,0-4.76-4.76H479.17a12.34,12.34,0,0,0-7.48,2.53c-5.72,4.36-17.37,14.47-23.33,19.68a10.82,10.82,0,0,0-3.68,8.13v53.79",
  style: {
    fill: "#d7d8d6",
    opacity: 0.35000000000000003
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 480.27,
  y: 261.19,
  width: 6.28,
  height: 6.28,
  rx: 1.18,
  ry: 1.18,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 491.21,
  y: 261.19,
  width: 6.28,
  height: 6.28,
  rx: 1.18,
  ry: 1.18,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 501.94,
  y: 261.19,
  width: 6.28,
  height: 6.28,
  rx: 1.18,
  ry: 1.18,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 480.37,
  y: 273.23,
  width: 6.28,
  height: 6.28,
  rx: 1.18,
  ry: 1.18,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 491.31,
  y: 273.23,
  width: 6.28,
  height: 6.28,
  rx: 1.18,
  ry: 1.18,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 502.04,
  y: 273.23,
  width: 6.28,
  height: 6.28,
  rx: 1.18,
  ry: 1.18,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 480.47,
  y: 285.28,
  width: 6.28,
  height: 6.28,
  rx: 1.18,
  ry: 1.18,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 491.4,
  y: 285.28,
  width: 6.28,
  height: 6.28,
  rx: 1.18,
  ry: 1.18,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 502.14,
  y: 285.28,
  width: 6.28,
  height: 6.28,
  rx: 1.18,
  ry: 1.18,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 480.57,
  y: 297.32,
  width: 6.28,
  height: 6.28,
  rx: 1.18,
  ry: 1.18,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 468.95,
  y: 273.23,
  width: 6.28,
  height: 6.28,
  rx: 1.18,
  ry: 1.18,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 469.05,
  y: 285.28,
  width: 6.28,
  height: 6.28,
  rx: 1.18,
  ry: 1.18,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 469.15,
  y: 297.32,
  width: 6.28,
  height: 6.28,
  rx: 1.18,
  ry: 1.18,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 491.5,
  y: 297.32,
  width: 6.28,
  height: 6.28,
  rx: 1.18,
  ry: 1.18,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 502.24,
  y: 297.32,
  width: 6.28,
  height: 6.28,
  rx: 1.18,
  ry: 1.18,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M720.45,263.69h42.5a9.43,9.43,0,0,1,9.43,9.43v61.63a0,0,0,0,1,0,0H711a0,0,0,0,1,0,0V273.11A9.43,9.43,0,0,1,720.45,263.69Z",
  style: {
    fill: "#d7d8d6",
    opacity: 0.7000000000000001
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 721.38,
  y: 278.16,
  width: 5.98,
  height: 5.98,
  rx: 1.17,
  ry: 1.17,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 721.38,
  y: 288.01,
  width: 5.98,
  height: 5.98,
  rx: 1.17,
  ry: 1.17,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 721.38,
  y: 297.86,
  width: 5.98,
  height: 5.98,
  rx: 1.17,
  ry: 1.17,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 732,
  y: 278.16,
  width: 5.98,
  height: 5.98,
  rx: 1.17,
  ry: 1.17,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 732,
  y: 288.01,
  width: 5.98,
  height: 5.98,
  rx: 1.17,
  ry: 1.17,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 732,
  y: 297.86,
  width: 5.98,
  height: 5.98,
  rx: 1.17,
  ry: 1.17,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 742.94,
  y: 278.16,
  width: 5.98,
  height: 5.98,
  rx: 1.17,
  ry: 1.17,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 742.94,
  y: 288.01,
  width: 5.98,
  height: 5.98,
  rx: 1.17,
  ry: 1.17,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 742.94,
  y: 297.86,
  width: 5.98,
  height: 5.98,
  rx: 1.17,
  ry: 1.17,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M579.24,326.23v-52.5c0-7.28-4-12.91-8.43-12l-36.59,7.62c-3.73.78-6.52,5.91-6.52,12v73.25",
  style: {
    fill: "#d7d8d6",
    opacity: 0.7000000000000001
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 550.16,
  y: 276.72,
  width: 6.25,
  height: 6.25,
  rx: 1.08,
  ry: 1.08,
  transform: "translate(1106.56 559.69) rotate(-180)",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 550.16,
  y: 287.02,
  width: 6.25,
  height: 6.25,
  rx: 1.08,
  ry: 1.08,
  transform: "translate(1106.56 580.28) rotate(-180)",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 550.16,
  y: 297.31,
  width: 6.25,
  height: 6.25,
  rx: 1.08,
  ry: 1.08,
  transform: "translate(1106.56 600.87) rotate(-180)",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 560.57,
  y: 276.72,
  width: 6.25,
  height: 6.25,
  rx: 1.08,
  ry: 1.08,
  transform: "translate(1127.39 559.69) rotate(-180)",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 560.57,
  y: 287.02,
  width: 6.25,
  height: 6.25,
  rx: 1.08,
  ry: 1.08,
  transform: "translate(1127.39 580.28) rotate(-180)",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 560.57,
  y: 297.31,
  width: 6.25,
  height: 6.25,
  rx: 1.08,
  ry: 1.08,
  transform: "translate(1127.39 600.87) rotate(-180)",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 539.74,
  y: 276.72,
  width: 6.25,
  height: 6.25,
  rx: 1.08,
  ry: 1.08,
  transform: "translate(1085.74 559.69) rotate(-180)",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 539.74,
  y: 287.02,
  width: 6.25,
  height: 6.25,
  rx: 1.08,
  ry: 1.08,
  transform: "translate(1085.74 580.28) rotate(-180)",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 539.74,
  y: 297.31,
  width: 6.25,
  height: 6.25,
  rx: 1.08,
  ry: 1.08,
  transform: "translate(1085.74 600.87) rotate(-180)",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.73,344V266.73c0-4.23-4.63-7.51-9.85-7L-.88,264.2c-4.35.45-7.61,3.43-7.61,7v68.77",
  style: {
    fill: "#d7d8d6",
    opacity: 0.7000000000000001
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M237,352.35V275.06c0-4.23-4.62-7.51-9.85-7l-42.75,4.43c-4.36.45-7.62,3.43-7.62,7v68.77",
  style: {
    fill: "#d7d8d6",
    opacity: 0.7000000000000001
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.42,327.54l.51-146.09c0-3.87,4.24-6.87,9-6.37l39.25,4c4,.41,7,3.14,7,6.37l-1.71,140",
  style: {
    fill: "#d7d8d6",
    opacity: 0.35000000000000003
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M453.16,323.46l1.76-68.25c.24-9.31-6-16.59-13.2-15.34l-77.08,13.44c-5.76,1-10.15,7.26-10.34,14.73l-1.51,58.5",
  style: {
    fill: "#00d38d"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M453.16,323.46l1.76-68.25c.24-9.31-6-16.59-13.2-15.34l-77.08,13.44c-5.76,1-10.15,7.26-10.34,14.73l-1.51,58.5",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient)"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 382.07,
  y: 262.63,
  width: 10.85,
  height: 10.85,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 382.07,
  y: 280.4,
  width: 10.85,
  height: 10.85,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#edf1f0"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 382.07,
  y: 280.4,
  width: 10.85,
  height: 10.85,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "url(#linear-gradient-2)"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 382.07,
  y: 298.17,
  width: 10.85,
  height: 10.85,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 404.43,
  y: 262.63,
  width: 10.85,
  height: 10.85,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 404.43,
  y: 280.4,
  width: 10.85,
  height: 10.85,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 404.43,
  y: 298.17,
  width: 10.85,
  height: 10.85,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 426.8,
  y: 262.63,
  width: 10.85,
  height: 10.85,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 426.8,
  y: 280.4,
  width: 10.85,
  height: 10.85,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 426.8,
  y: 298.17,
  width: 10.85,
  height: 10.85,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#edf1f0"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 426.8,
  y: 298.17,
  width: 10.85,
  height: 10.85,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "url(#linear-gradient-3)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M317.62,271.59c-.77,6.82-2.09,17.66-2.89,24.24a5.75,5.75,0,0,0,5.06,6.4l18.58,2.46a6.34,6.34,0,0,0,7.07-5.12l4.14-24.3a5.75,5.75,0,0,0-5.08-6.69l-19.83-2.42A6.33,6.33,0,0,0,317.62,271.59Z",
  style: {
    fill: "#006b3f"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M330.07,283.89v36.26a1.25,1.25,0,0,0,2.5,0V283.89a1.25,1.25,0,0,0-2.5,0Z",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M322.67,293l8,5.62c1.32.92,2.57-1.24,1.26-2.16l-8-5.62c-1.32-.92-2.57,1.25-1.26,2.16Z",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M338.71,285.22l-8,5.61c-1.31.92-.06,3.09,1.26,2.16l8-5.61c1.3-.92.06-3.09-1.27-2.16Z",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M345.83,322.19c-1.11-1.82-3.21-4.22-5.66-3.76-.72.13-1.09.77-1.57,1.22-.89-1.5-1.89-2.71-3.73-3a4.54,4.54,0,0,0-3.4.71c-2.09-1.48-3.24-3.42-6.17-3.75a7.85,7.85,0,0,0-5.33,1.51,7.94,7.94,0,0,0-2.87,3.75,3.67,3.67,0,0,0-4-.08,8.33,8.33,0,0,0-3.07,3.8",
  style: {
    fill: "#006b3f"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M501.82,280.49,495,298.66a5.25,5.25,0,0,0,4.91,7.09h14.44a5.25,5.25,0,0,0,4.91-7.1l-6.82-18.16a5.26,5.26,0,0,0-4.92-3.41h-.8A5.25,5.25,0,0,0,501.82,280.49Z",
  style: {
    fill: "#079d56"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M501.82,280.49,495,298.66a5.25,5.25,0,0,0,4.91,7.09h14.44a5.25,5.25,0,0,0,4.91-7.1l-6.82-18.16a5.26,5.26,0,0,0-4.92-3.41h-.8A5.25,5.25,0,0,0,501.82,280.49Z",
  style: {
    fill: "#006b3f"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M505.46,292.39v29.48a1.25,1.25,0,0,0,2.5,0V292.39a1.25,1.25,0,0,0-2.5,0Z",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M506.71,300.89c3.29-.08,6.85-1.7,7.74-5.1a1.25,1.25,0,0,0-2.41-.67c-.6,2.29-3.19,3.22-5.33,3.27a1.25,1.25,0,0,0,0,2.5Z",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M754.39,327.14v-72.5c0-9.89,6.27-17.44,13.21-15.92l74.53,16.37c5.57,1.22,9.68,8,9.68,15.92v62.13",
  style: {
    fill: "#f4b01a"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M754.39,327.14v-72.5c0-9.89,6.27-17.44,13.21-15.92l74.53,16.37c5.57,1.22,9.68,8,9.68,15.92v62.13",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-4)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M754.39,327.14v-72.5c0-9.89,6.27-17.44,13.21-15.92l74.53,16.37c5.57,1.22,9.68,8,9.68,15.92v62.13",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-4)"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 769.04,
  y: 263.08,
  width: 10.54,
  height: 10.54,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 769.04,
  y: 280.35,
  width: 10.54,
  height: 10.54,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 769.04,
  y: 280.35,
  width: 10.54,
  height: 10.54,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "url(#linear-gradient-6)"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 769.04,
  y: 297.62,
  width: 10.54,
  height: 10.54,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 790.77,
  y: 263.08,
  width: 10.54,
  height: 10.54,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 790.77,
  y: 280.35,
  width: 10.54,
  height: 10.54,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 790.77,
  y: 297.62,
  width: 10.54,
  height: 10.54,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "url(#linear-gradient-7)"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 812.51,
  y: 263.08,
  width: 10.54,
  height: 10.54,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 812.51,
  y: 280.35,
  width: 10.54,
  height: 10.54,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 812.51,
  y: 297.62,
  width: 10.54,
  height: 10.54,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.5,320.37v-71c0-9.69,6.14-17.09,12.94-15.6l73,16c5.46,1.2,9.48,7.81,9.48,15.59v60.87",
  style: {
    fill: "#f4b01a"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.5,320.37v-71c0-9.69,6.14-17.09,12.94-15.6l73,16c5.46,1.2,9.48,7.81,9.48,15.59v60.87",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-8)"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 87.02,
  y: 261.6,
  width: 9.46,
  height: 9.46,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 87.02,
  y: 277.09,
  width: 9.46,
  height: 9.46,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.36,302.53H86.72a.91.91,0,0,1-.91-.91V294a.92.92,0,0,1,.91-.92h7.64c.5,0,2.13-.07,2.13.44l-1.22,8.11A.91.91,0,0,1,94.36,302.53Z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 106.53,
  y: 261.6,
  width: 9.46,
  height: 9.46,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 106.53,
  y: 277.09,
  width: 9.46,
  height: 9.46,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#edf1f0"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 106.53,
  y: 277.09,
  width: 9.46,
  height: 9.46,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "url(#linear-gradient-9)"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 106.53,
  y: 292.59,
  width: 9.46,
  height: 9.46,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 143.64,
  y: 261.6,
  width: 9.46,
  height: 9.46,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 143.64,
  y: 277.09,
  width: 9.46,
  height: 9.46,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#edf1f0"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 143.64,
  y: 277.09,
  width: 9.46,
  height: 9.46,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "url(#linear-gradient-10)"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 143.64,
  y: 292.59,
  width: 9.46,
  height: 9.46,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 126.04,
  y: 261.6,
  width: 9.46,
  height: 9.46,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#edf1f0"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 126.04,
  y: 261.6,
  width: 9.46,
  height: 9.46,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "url(#linear-gradient-11)"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 126.04,
  y: 277.09,
  width: 9.46,
  height: 9.46,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 126.04,
  y: 292.59,
  width: 9.46,
  height: 9.46,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M493.21,323.09c.9-1.73,5-4.26,7.37-5.07.74-.26,2.65-.3,3.19-.63.83-.52,1.43-1.93,2.22-2.64,3.83-3.45,8.58-2.65,11.89,1.32,4.86-3.67,11.57-3.29,15.27,2.1,5.26-4.25,12.74.39,14.31,5.84",
  style: {
    fill: "#ee8322"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M718.93,321.54c2.88-2,10.69-12.05,13.63-5.19,1.74-5.48,8.36-10.92,14.31-10.69,8.54.32,5.38,10.78,6.84,16.74",
  style: {
    fill: "#006b3f"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: -6.9,
  y: 321.7,
  width: 853.71,
  height: 56.16,
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.76,244.65l12.71,33.9a9.8,9.8,0,0,1-9.17,13.24H-3.64a9.8,9.8,0,0,1-9.17-13.25L-.07,244.65a9.79,9.79,0,0,1,9.17-6.36h1.49A9.8,9.8,0,0,1,19.76,244.65Z",
  style: {
    fill: "#079d56"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.76,244.65l12.71,33.9a9.8,9.8,0,0,1-9.17,13.24H-3.64a9.8,9.8,0,0,1-9.17-13.25L-.07,244.65a9.79,9.79,0,0,1,9.17-6.36h1.49A9.8,9.8,0,0,1,19.76,244.65Z",
  style: {
    fill: "#079d56"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.38,266.86v55a1.25,1.25,0,0,0,2.5,0v-55a1.25,1.25,0,0,0-2.5,0Z",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.63,283.42c3.9-.1,8.16-2,9.21-6.05a1.25,1.25,0,0,0-2.41-.67c-.76,2.93-4,4.15-6.8,4.22a1.25,1.25,0,0,0,0,2.5Z",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M736.19,261.57c-1,8.41-2.58,21.8-3.58,29.92a7.12,7.12,0,0,0,6.25,7.91l22.95,3a7.83,7.83,0,0,0,8.72-6.32l5.12-30a7.09,7.09,0,0,0-6.27-8.25l-24.49-3A7.8,7.8,0,0,0,736.19,261.57Z",
  style: {
    fill: "#006b3f"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M736.19,261.57c-1,8.41-2.58,21.8-3.58,29.92a7.12,7.12,0,0,0,6.25,7.91l22.95,3a7.83,7.83,0,0,0,8.72-6.32l5.12-30a7.09,7.09,0,0,0-6.27-8.25l-24.49-3A7.8,7.8,0,0,0,736.19,261.57Z",
  style: {
    fill: "#079d56"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M751.85,276.75v44.78a1.25,1.25,0,0,0,2.5,0V276.75a1.25,1.25,0,0,0-2.5,0Z",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M742.56,287.73l9.91,6.94c1.32.92,2.57-1.24,1.26-2.16l-9.9-6.93c-1.32-.93-2.58,1.24-1.27,2.15Z",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M762.38,278.64l-9.91,6.94c-1.31.91-.06,3.08,1.26,2.15l9.91-6.93c1.31-.92.06-3.08-1.26-2.16Z",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M489.84,257l10.4,31.27c2,5.91-1.91,12.22-7.5,12.22h-22c-5.6,0-9.47-6.31-7.5-12.22L473.62,257a8.13,8.13,0,0,1,7.5-5.86h1.22A8.11,8.11,0,0,1,489.84,257Z",
  style: {
    fill: "#079d56"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M481.13,271.07v45a1.25,1.25,0,0,0,2.5,0v-45a1.25,1.25,0,0,0-2.5,0Z",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M482.38,293.33c3-.08,6.22-1.55,7-4.65A1.25,1.25,0,0,0,487,288c-.52,2-2.86,2.76-4.61,2.81a1.25,1.25,0,0,0,0,2.5Z",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M482.38,278.8c3-.08,6.22-1.55,7-4.65a1.25,1.25,0,0,0-2.41-.66c-.52,2-2.86,2.76-4.61,2.81a1.25,1.25,0,0,0,0,2.5Z",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M481.72,284.92c-1.75,0-4.09-.79-4.61-2.81a1.25,1.25,0,0,0-2.41.67c.8,3.09,4,4.57,7,4.64a1.25,1.25,0,0,0,0-2.5Z",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M-29.55,327.36c2.84-1.47,4.54-5,7.94-5.51,2.59-.37,4.16,1.18,6.37-.05,2.73-1.51,3.57-4.3,7.08-4.78a8.35,8.35,0,0,1,6.22,1.3c3.82-2.71,5.93-6.26,11.29-6.87,5-.57,10.34,2.21,13.3,6.16,1.55,2.06.91,2.11,3.49,2.34,2.06.18,3.4-.27,5.46,1a15.16,15.16,0,0,1,5.62,6.95",
  style: {
    fill: "#006b3f"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M-15,365.6c16.63-10.09,32.27-16.44,52.64-19.87a195.15,195.15,0,0,1,61.73-.34c19.81,3.07,37.5,8.58,55.48,16,10.39,4.31,55.23,18.06,67.32,19.22,26.5,2.56,55.77-3.83,79.89-12.55,12.28-4.44,74.83-29,134.58-25.65,55.1,3.06,105.47,20.83,158.7,31.53,29.63,6,102.76.68,122.51-4.38,25.84-6.63,49.86-17.56,76.32-22.67,11.47-2.21,23.41-2.58,35.16-2.86,5-.12,10.43-.35,15.17.82",
  style: {
    fill: "none",
    stroke: "#edf1f0",
    strokeMiterlimit: 10,
    strokeWidth: 28
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "197.41 165.9 199.94 156.54 210.67 157.7 205.72 178.34",
  style: {
    fill: "#ee8322"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M227.13,164.87a67.12,67.12,0,0,1,5.47,25.33h-9.73l-4-17.14",
  style: {
    fill: "#ee8322"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M225.13,137.76l6.75.1,6.56-13.68h5.37l-5.58,18.28a4.91,4.91,0,0,1-4.57,3.47l-9.08.22",
  style: {
    fill: "#c1813e"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M197,143.24l-8.84,16.95-12.76,8.57c-1.82.73-3.62,1.34-4.85,3s-1.65,4.35.18,5.74c3.11,2.38,6.5-2.64,8.14-4.63L191,167.19a11.8,11.8,0,0,0,5.16-4.65l7.16-12",
  style: {
    fill: "#c1813e"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M200.94,154l-7.72-8.3,5.86-7.6a5.63,5.63,0,0,1,9.36.66h0a5.63,5.63,0,0,1-.54,6.35Z",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M200.94,154l-7.72-8.3,5.86-7.6a5.63,5.63,0,0,1,9.36.66h0a5.63,5.63,0,0,1-.54,6.35Z",
  style: {
    fill: "url(#linear-gradient-12)"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M229.89,136.87l-2.73,10.93-9.5-.76a5.6,5.6,0,0,1-4.53-8.15h0a5.6,5.6,0,0,1,5.58-3Z",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M229.89,136.87l-2.73,10.93-9.5-.76a5.6,5.6,0,0,1-4.53-8.15h0a5.6,5.6,0,0,1,5.58-3Z",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-13)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M206.45,137.78l9-1.06s.08,0,.08-.05l-.56-3.6,2.35-.34c1.83-.42,1.3-2.46,1.07-3.76l-.54-3c.39,0,.87,0,1-.41a1,1,0,0,0-.11-.71,35.89,35.89,0,0,0-2.3-4.6,12.28,12.28,0,0,0-3.45-3.76c-1.15-.78-2.4-.32-3.73.1a8.81,8.81,0,0,0-3.49,2.24,8.12,8.12,0,0,0-1.64,2.27,7.64,7.64,0,0,0,1.87,9.07Z",
  style: {
    fill: "#c1813e"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 215.26,
  cy: 123.84,
  r: 0.42,
  style: {
    fill: "#0e1010"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M214.61,126.37l2.27.51s-.4,1.11-1.27,1S214.61,126.37,214.61,126.37Z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "214.94 133.07 211.56 133.47 215.29 135.3",
  style: {
    fill: "#ebb990",
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M202.26,130.73a10.67,10.67,0,0,1-1.23-3.8c-.48-3-.92-6.41,1.79-8.5a7.71,7.71,0,0,1,2.72-1.23c1.8-.45,3-.5,4.35-1.85,1.07-1,2.62-1.9,4.05-1a3.44,3.44,0,0,1,1.56,3.44c-.61,2.85-4.07,3.31-6.41,3.92l.85,4.78a2.71,2.71,0,0,0-2.94-.23,2.18,2.18,0,0,0-.77,1.49c-.17,1.43.64,2.09,1.43,3.06.46.57.76.32.39,1.19a2.29,2.29,0,0,1-1.7,1,4.25,4.25,0,0,1-3.83-1.9C202.43,131,202.34,130.86,202.26,130.73Z",
  style: {
    fill: "#8b5624"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M199.42,154.78l2-15.33a4.16,4.16,0,0,1,4.13-3.62H216.4a4.16,4.16,0,0,1,4,2.87l5.25,16.06",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M199.42,154.78l2-15.33a4.16,4.16,0,0,1,4.13-3.62H216.4a4.16,4.16,0,0,1,4,2.87l5.25,16.06",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-14)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M272.6,193l-1.69-6.18-3.41-.37c-2.66-.52-2-3.49-1.73-5.38l.63-4.41c-.56,0-1.26,0-1.47-.54a1.39,1.39,0,0,1,.12-1,53.61,53.61,0,0,1,3.1-6.76,17.88,17.88,0,0,1,4.81-5.6c1.63-1.18,3.46-.58,5.4,0a12.86,12.86,0,0,1,5.15,3.07A11.77,11.77,0,0,1,286,169a11.06,11.06,0,0,1-2.27,13.2l3.7,8.9",
  style: {
    fill: "#c1813e"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 269.92,
  cy: 172.28,
  r: 0.61,
  style: {
    fill: "#0e1010"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M271.74,176.58l-3.27.85s.64,1.58,1.89,1.35S271.74,176.58,271.74,176.58Z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "270.9 186.84 275.82 187.25 271.74 189.73",
  style: {
    fill: "#ebb990",
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M266.72,201.47l-9.11,2.92-12-11.67-10.21,8,16.16,15.54a7.35,7.35,0,0,0,7.66,1.46",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M267.42,196.21l-16.55,18.33-18.32-.76.76,11.86,17.45,1.4a9.48,9.48,0,0,0,7.45-2.72l7-6.9",
  style: {
    fill: "#c1813e"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M182.61,191.12,170.08,209.5l.58-22.67-7.3-3.24-4.21,25.13a11.29,11.29,0,0,0,7,12.66h0a11.62,11.62,0,0,0,13.47-3.59l12-15.26",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M176.13,195.34l15.54,9.59,10.18-11.65a9.08,9.08,0,0,0-4-14.58h0a9.08,9.08,0,0,0-9.86,2.84Z",
  style: {
    fill: "#00d38d"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M176.13,195.34l15.54,9.59,10.18-11.65a9.08,9.08,0,0,0-4-14.58h0a9.08,9.08,0,0,0-9.86,2.84Z",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-15)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M203.52,182.74h15.7l2-10,3.85.51c3.06.17,3.16-3.29,3.37-5.44l.52-5c.6.19,1.38.33,1.77-.18a1.61,1.61,0,0,0,.14-1.17,59.52,59.52,0,0,0-1.56-8.28c-.81-2.86-1.83-7-5.1-7.61-3.79-.76-7.68.36-11.37,1.55-3.46,1.11-5.39,4-6.18,7.48a12.47,12.47,0,0,0-.09,5,39.59,39.59,0,0,0,1.83,4.55Z",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 225.31,
  cy: 157.71,
  r: 0.67,
  style: {
    fill: "#0e1010"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M226.17,164.61a2.84,2.84,0,0,1-2-1.79l.6-.23a2.29,2.29,0,0,0,2,1.49v.64A3.13,3.13,0,0,1,226.17,164.61Z",
  style: {
    fill: "#8b5624"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M218.06,156a3.62,3.62,0,0,1,3.35-2.69c1.59-.2,3.2.07,4.8-.06a9.52,9.52,0,0,0,3.19-.83,5.33,5.33,0,0,0-.58-10,4.73,4.73,0,0,0-4.91,1.55,12.91,12.91,0,0,0-3.78-2.23,5.93,5.93,0,0,0-4.31.05,8.23,8.23,0,0,0-3.29,3.25,6.89,6.89,0,0,0-4.06-1.1,4.37,4.37,0,0,0-3.11,2.52,8.77,8.77,0,0,0-.7,4.06,4.45,4.45,0,0,0-4.84,5.9,7.21,7.21,0,0,0,3,3.36c-.29-.2-.66,2-.64,2.18a5.52,5.52,0,0,0,.86,2.12,5.66,5.66,0,0,0,4,2.95,5.23,5.23,0,0,0,4.83-2,7.39,7.39,0,0,1-2.64-2.69,4.47,4.47,0,0,1-.13-3.16,4.22,4.22,0,0,1,1.23-2,3.35,3.35,0,0,1,5.29,1.33,1.4,1.4,0,0,0,.45.76.83.83,0,0,0,1-.21,2.32,2.32,0,0,0,.43-1.05A17.26,17.26,0,0,1,218.06,156Z",
  style: {
    fill: "#e8a51f"
  }
}), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  }
}, /*#__PURE__*/React.createElement("polyline", {
  points: "221.19 172.77 215.23 171.81 220.56 175.99",
  style: {
    fill: "#ebb990"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M191.58,343.17,189.2,357a2.71,2.71,0,0,1-2.69,2.21H159.79a4.54,4.54,0,0,1-1.64-8.82l.21-.07c7-2.37,18.86-7.22,18.86-7.22",
  style: {
    fill: "#727d79"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M242.76,343.17,245.14,357a2.71,2.71,0,0,0,2.69,2.21h26.72a4.54,4.54,0,0,0,1.63-8.82l-.2-.07c-7-2.37-18.86-7.22-18.86-7.22",
  style: {
    fill: "#727d79"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M251.65,195.34l-15.54,9.59-10.17-11.65a9.07,9.07,0,0,1,4-14.58h0a9.08,9.08,0,0,1,9.86,2.84Z",
  style: {
    fill: "#00d38d"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M251.65,195.34l-15.54,9.59-10.17-11.65a9.07,9.07,0,0,1,4-14.58h0a9.08,9.08,0,0,1,9.86,2.84Z",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-16)"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "189.89 232.65 174.43 343.58 192.22 343.58 212.49 257.72 242.5 343.58 259.71 343.58 237.92 232.65",
  style: {
    fill: "#ee8322"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "239 232.65 188.84 232.65 195.72 178.24 231.93 178.24 239 232.65",
  style: {
    fill: "#00d38d"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "239 232.65 188.84 232.65 195.72 178.24 231.93 178.24 239 232.65",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-17)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.51,185.07c-.56-1.48.39-6.49.7-8a17.83,17.83,0,0,1,1.49-4.51c1.22-2.36,3.57-5.59,5.86-7,1-.63,1.93-.45,2.36.8.55,1.6-.51,3.31-1,4.77a6.39,6.39,0,0,0-.39,3.92c.29,1.08.92,2,1.18,3.13a10.89,10.89,0,0,1,.07,4.18c-.3,1.73-2.16,3.18-3.09,4.45",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M274.26,192.29a12.08,12.08,0,0,0-8.79,7.09S259.14,211,260.81,215a4.71,4.71,0,0,0,3.68,3l-.7,20.28,35.95.83-1.51-37.92a10.58,10.58,0,0,0-12.58-11.07Z",
  style: {
    fill: "#f4b01a"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M274.26,192.29a12.08,12.08,0,0,0-8.79,7.09S259.14,211,260.81,215a4.71,4.71,0,0,0,3.68,3l-.7,20.28,35.95.83-1.51-37.92a10.58,10.58,0,0,0-12.58-11.07Z",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-18)"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "283.4 301.72 290.51 354.91 300.96 354.91 300.35 303.64",
  style: {
    fill: "#c1813e"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M290.16,352.3c-3.19,5.47-12.53,2.37-12.87,9.39h21.52a2.5,2.5,0,0,0,2.51-2.56l-.15-6.37",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M265.08,352c-3.19,5.47-12.52,2.37-12.86,9.39h21.51a2.51,2.51,0,0,0,2.51-2.56l-.15-6.37",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "278.75 302.82 275.88 351.83 264.23 352.37 265.63 296.53",
  style: {
    fill: "#c1813e"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M298.14,232.26l-34.09-.36-17.32,63.77a8,8,0,0,0,7.69,10.08l48.16.12a9.81,9.81,0,0,0,9.59-12Z",
  style: {
    fill: "#e65e9b"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M285,215.3l7.56,16.58a5,5,0,0,1,.43,2.37l-1.71,24.27c-.48,2.79-1.34,5.46-1.27,8.38.07,2.58.35,6.67,3.2,7.67,5.67,2,6.52-6.27,6.47-10.12,0-1.62-1-4-.77-5.27l5.41-22a12.45,12.45,0,0,0,0-5.82l-4.24-17.82",
  style: {
    fill: "#c1813e"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M302.05,215.76l-18.93,1.49-3.86-15.6a9.43,9.43,0,0,1,10.59-11.59h0a9.42,9.42,0,0,1,7.77,7.31Z",
  style: {
    fill: "#f4b01a"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M302.05,215.76l-18.93,1.49-3.86-15.6a9.43,9.43,0,0,1,10.59-11.59h0a9.42,9.42,0,0,1,7.77,7.31Z",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-19)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M302.18,201.07c2.12,3.27,3.59,7,7.91,8.1a13.56,13.56,0,0,0,6.75-.34c3-.76,4.8-2.15,6.9-4.45,3.55-3.89,3.52-10.49-.81-13.89-1.86-1.45-4.32-1.85-6.47-2.71-2.5-1-3.84-2.83-5.47-4.85-2.08-2.54-4-4.39-7.12-5.58-2.24-.86-4.67-.86-6.91-1.67-4.69-1.7-6.51-5.71-9.72-9.09-2.5-2.64-5.61-4-9-5-1.77-.55-4.41-1.37-6.2-.5-2.86,1.38-.12,4.81,1.66,5.87a17.42,17.42,0,0,0,5.24,1.76l-1,7c1.21-.85,3-1.32,4.24-.48a3.17,3.17,0,0,1,1.19,2.13c.41,2.68-1.53,4.24-3.52,5.52.57,1.44,1.43,3.33,2.75,4.27s2.59.72,3.64,1.85c1.2,1.29,1.29,3.3,2.4,4.71a7.87,7.87,0,0,0,4.27,2.47c2.9.82,6,.71,8.07,3.3A19.16,19.16,0,0,1,302.18,201.07Z",
  style: {
    fill: "#8b5624"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M236.78,297.82l-5.36,10.64c-1.88,3.73-4.29,7.57-5.45,11.56a4.61,4.61,0,0,0-.31,2.45c.34,1.31,1.57,3.95,3.36,3.25s2.5-3.1,3.39-4.58a6.68,6.68,0,0,0,1.05,1.77c1.22,1,1.38-.58,1.3-1.4a14.53,14.53,0,0,0-.71-3.05l8.64-13.61",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M272.42,289.08l11.76.27,4.37-11.62,5.88.82-5.77,17.56a3.47,3.47,0,0,1-3.32,2.38l-14.43-.11",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M273.72,287.67,272,299.47l-10.1.17a5.93,5.93,0,0,1-5.6-8.13h0a5.93,5.93,0,0,1,5.57-3.72Z",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M273.72,287.67,272,299.47l-10.1.17a5.93,5.93,0,0,1-5.6-8.13h0a5.93,5.93,0,0,1,5.57-3.72Z",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-20)"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "244.12 332.6 239.26 353.41 250.36 353.41 255.49 333.85",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M239.27,351.77a6.49,6.49,0,0,1-3.17,3.48c-1.4.79-2.95,1.28-4.4,2A5.4,5.4,0,0,0,230,358.4a2.39,2.39,0,0,0-.69,1.92,1.54,1.54,0,0,0,1.39,1.34h18l2.2-9.36",
  style: {
    fill: "#e65e9b"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "271.03 332.67 275.89 353.48 264.78 353.48 259.65 333.92",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M269.16,307.63l8.72,23.53a3.2,3.2,0,0,1-2.9,4.36H240.25a3.18,3.18,0,0,1-3.06-3.75l6-23.45",
  style: {
    fill: "#00d38d"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M249.51,289.25l9.81-.51s.09,0,.09-.05l-.35-3.95,2.57-.2c2-.32,1.59-2.57,1.43-4l-.36-3.33c.42,0,.94,0,1.12-.36a1.07,1.07,0,0,0-.07-.78,39.45,39.45,0,0,0-2.16-5.15,13.32,13.32,0,0,0-3.47-4.33c-1.2-.93-2.59-.53-4.06-.16a9.68,9.68,0,0,0-3.95,2.18,8.91,8.91,0,0,0-1.94,2.34,8.29,8.29,0,0,0,1.38,10Z",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 260.07,
  cy: 274.76,
  r: 0.46,
  style: {
    fill: "#0e1010"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M261.37,278.77a1.71,1.71,0,0,1-1.68-.85",
  style: {
    fill: "none",
    stroke: "#8b5624",
    strokeMiterlimit: 10,
    strokeWidth: "0.25px"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "259.06 284.74 255.36 284.94 259.27 287.19",
  style: {
    fill: "#ebb990",
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M245.47,281.3a11.66,11.66,0,0,1-1.06-4.21c-.23-2.4-.58-5.44,1-7.5a7.87,7.87,0,0,1,3.25-2.17l2.64-1.18a11.24,11.24,0,0,1,4.48-1.28c3.7,0,5.22,3.91,1.76,5.82a13.21,13.21,0,0,1-4,1.2l.58,5.25a2.93,2.93,0,0,0-3.17-.46,2.36,2.36,0,0,0-.95,1.56c-.29,1.54.54,2.31,1.33,3.43.46.64.8.39.34,1.31a2.51,2.51,0,0,1-1.92,1,4.64,4.64,0,0,1-4-2.34C245.64,281.6,245.55,281.45,245.47,281.3Z",
  style: {
    fill: "#e8a51f"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 257.51,
  cy: 261.33,
  r: 3.81,
  style: {
    fill: "#e8a51f"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 241.57,
  cy: 267.71,
  r: 4.64,
  style: {
    fill: "#e8a51f"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M241.67,310.14,244,292a4.94,4.94,0,0,1,4.91-4.31h12.88a4.94,4.94,0,0,1,4.7,3.41l6.24,19.07",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M241.67,310.14,244,292a4.94,4.94,0,0,1,4.91-4.31h12.88a4.94,4.94,0,0,1,4.7,3.41l6.24,19.07",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-21)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M275.88,351.83a6.49,6.49,0,0,0,3.17,3.48c1.4.79,2.95,1.29,4.4,2a5.87,5.87,0,0,1,1.73,1.17,2.41,2.41,0,0,1,.69,1.92,1.55,1.55,0,0,1-1.39,1.35h-18l-2.21-9.36",
  style: {
    fill: "#e65e9b"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M243.31,306.39l-8-8.59,6.07-7.86a5.83,5.83,0,0,1,9.68.68h0a5.82,5.82,0,0,1-.56,6.57Z",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M243.31,306.39l-8-8.59,6.07-7.86a5.83,5.83,0,0,1,9.68.68h0a5.82,5.82,0,0,1-.56,6.57Z",
  style: {
    fill: "url(#linear-gradient-22)"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M288.52,279.49c-1.65-1.51,0-10.24,2.55-10.95s2,2.74,2.19,4.38,1.24,2.7,1.65,4.19a4.68,4.68,0,0,1-2,4.75",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M238.2,125.82l-.6-4.49c-.09-.61-1.1-4.91.4-3.81.73.53.7,2,1.18,2.69,1.23-1.8,3.77-7.08,6.27-3.54,1,1.44.35,3.46-.4,4.89l-1.93,4.57",
  style: {
    fill: "#c1813e"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M197.51,165.46s-4.29,9.47-5.47,25.32h9.73l3.95-17.14",
  style: {
    fill: "#ee8322"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M229,173.9s3.49,2.29,3.61,16.3h-9.73l-2.78-12.08",
  style: {
    fill: "#ee8322"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M192.42,190.37a12.67,12.67,0,0,1-3.83,3.17c-1.38.88-2.6,2-1.57,3.6h11.87a1.2,1.2,0,0,0,1.17-.89l1.65-5.88",
  style: {
    fill: "#e65e9b"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M232.06,189.63a12.72,12.72,0,0,0,3.82,3.16c1.38.88,2.61,2,1.58,3.61H225.85a1.57,1.57,0,0,1-1.51-1.15l-1.58-5.62",
  style: {
    fill: "#e65e9b"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M447.75,337.35a26.5,26.5,0,0,1,2.21,6.36,3.67,3.67,0,0,0,.43,1.27,1.16,1.16,0,0,0,1.15.56c.29-.07.53-.29.82-.33s.77.2,1.13.08c.6-.19.51-1.06.32-1.66a28.33,28.33,0,0,1-1.08-4.43,4.74,4.74,0,0,1-.05-1.72,6.46,6.46,0,0,1,.47-1.27,27.53,27.53,0,0,0,1.24-6.14",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M481.22,330.82l6,13.44c.22.36.21.09.24.51a.42.42,0,0,1-.06.31.44.44,0,0,1-.33.14,3.45,3.45,0,0,1-2.26-.53c-.24-.16-.47-.35-.72-.49s-.43-.19-.63-.31a2.11,2.11,0,0,1-.5-.49,3.43,3.43,0,0,1-.67-2.14l-4.15-7.06",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("g", {
  style: {
    clipPath: "url(#clip-path-2)"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M441.54,320.12c-2.16-2.6-2.71-6.18-2.65-9.56a21.14,21.14,0,0,1,1.44-7.79,13.54,13.54,0,0,1,3.13-4.65.55.55,0,0,1,.89.61,24.06,24.06,0,0,0-2.07,8.4,13.51,13.51,0,0,0,3.49,10.15,24.41,24.41,0,0,1,12.4-1c3,.53,6,1.66,9.06,1.83,3.41.19,6.76-.81,10-1.89l3.69-5.69a7.75,7.75,0,0,1,4.91-3.4l1-.2a7,7,0,0,1,5.63,1.2c1.8,1.44,2.53,3.85,2.77,6.14L502,318c.34,0,.13.7,0,1a4.13,4.13,0,0,1-.71.74c-.35.35-.57.81-.92,1.15a3.88,3.88,0,0,1-3.38.67,7.5,7.5,0,0,0-3.55-.08,5,5,0,0,0-1.75,1.22,14.58,14.58,0,0,0-2.51,3.32c-1.18,2.09-2.1,3.49-4.43,4.48a15.11,15.11,0,0,0-3.9,2,9.85,9.85,0,0,0-2.17,2.93,69,69,0,0,0-3.86,9.07c-.19.51.18.47,0,.92a1.56,1.56,0,0,1-.94.82,4.57,4.57,0,0,1-1.74.37,1.69,1.69,0,0,1-1.21-.53,2.56,2.56,0,0,1-.24-2.24c.2-.92.48-.85.84-1.72l2.23-8.34a65,65,0,0,1-20.47-1.6c-.67,2.71-3,4.61-4.71,6.84a26.5,26.5,0,0,0-3.58,7.25c-.41,1.14-1.94.76-3,.16a.9.9,0,0,1-.42-.42,1.16,1.16,0,0,1,.11-.81,9.12,9.12,0,0,0,.61-3,17.9,17.9,0,0,0-.94-6.49,27.54,27.54,0,0,1-1.59-7.86A13.94,13.94,0,0,1,441.54,320.12Z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M453.16,313.82c-1.16.63-5.14,6.12-4.35,7.58s3.36-.15,4.1-.87c-.25,1.7-1.69,4.16-.4,5.84,1.8,2.33,5-.46,6.48-1.93.57-.56,1.51-2.37,2.22-2.64s.88.52,1.81.46c3.13-.18,3.89-2.9,5.64-5a2.56,2.56,0,0,0-.58.46",
  style: {
    fill: "#070707"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M460.3,334.91c.72-2.18,3.7-8.2,6.46-5.42,1.14-2,3.4-5.69,6.22-5.17s1.58,3.17,1.28,4.83c3.11-.41,3.27,2.76,1.94,5a16.65,16.65,0,0,1-3,3.61c-.74.68-1.75,1.15-2.27,2",
  style: {
    fill: "#070707"
  }
})), /*#__PURE__*/React.createElement("circle", {
  cx: 491.75,
  cy: 313.04,
  r: 0.62,
  style: {
    fill: "#070707"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M502.17,318a2.34,2.34,0,0,1-.38,1.09.59.59,0,0,1-.24.23c-.23.1-.48-.06-.67-.21-.4-.33-.77-.67-1.13-1a3.31,3.31,0,0,1-.39-.45.63.63,0,0,1-.12-.37.5.5,0,0,1,.46-.41,1.49,1.49,0,0,1,.65.14Z",
  style: {
    fill: "#070707"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M495.05,317.77a5.28,5.28,0,0,0,3.09,1.6c.38.06.55-.54.16-.59a4.72,4.72,0,0,1-2.81-1.44c-.27-.29-.71.14-.44.43Z",
  style: {
    fill: "#727d79"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M447.36,324.8a3.69,3.69,0,0,0-1.18.81c-.64.75-1.47,3.52-.1,4,1,.35,2.3-1.15,2.76-1.85s1.46-2.45.38-3.08A2.17,2.17,0,0,0,447.36,324.8Z",
  style: {
    fill: "#070707"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M401.06,336.39l2.43,9.16a1.66,1.66,0,0,0,1.6,1.22h15.09a1.81,1.81,0,0,0,.77-3.46,33.65,33.65,0,0,0-3.59-1.24c-2-.66-6.29-2.44-6.4-5",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M408.66,271.12c2.9,1.59,6.47,1.83,9.6,2.78a83.5,83.5,0,0,1,11.13,4.33A54.2,54.2,0,0,1,448,292.07c4.47,5.28,8.4,10.93,13.2,15.95a29.58,29.58,0,0,0,15,8.78A.63.63,0,0,0,477,316l-.08-.31a.62.62,0,0,0-1.2.33c-.38-1.42-2.88-1.44-4.05-1.9a22.12,22.12,0,0,1-6.86-4.34,75.8,75.8,0,0,1-6.3-6.62c-4.44-5.06-8.07-10.84-12.88-15.58A56.33,56.33,0,0,0,430,277.15c-2.65-1.25-5.37-2.35-8.13-3.33-3.95-1.42-8.94-1.77-12.6-3.78-.7-.38-1.34.7-.63,1.08Z",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M474.45,316.11,486,329.73c1,1.23,2.8-.54,1.77-1.77l-11.58-13.62c-1-1.23-2.8.55-1.76,1.77Z",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M487.92,311.29q-.29,3.91-.87,7.82a2.26,2.26,0,0,1-.43,1.19,2.15,2.15,0,0,1-1.49.52,21.79,21.79,0,0,1-6.34-.44A1.35,1.35,0,0,1,478,320c-.36-.39-.2-1,0-1.49a73.33,73.33,0,0,1,4.33-9.4c.77-1.39,2.77-1.88,4.36-1.81a1.2,1.2,0,0,1,.56.11c.49.24.6.88.64,1.42A16.56,16.56,0,0,1,487.92,311.29Z",
  style: {
    fill: "#070707"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M358,330.53l-3.73,7.13,7.71,7.86a1.41,1.41,0,0,0,1,.43l7,.15c1.44,0,2.09-2.06-2-4.81-2-1.36-4.2-4-2.37-6.38",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M372.08,229.3l10.48,4.47,4.4-7.84,2.74-.07c2.16-.23,1.84-2.65,1.75-4.17l-.2-3.57c.44.07,1,.08,1.21-.32a1.14,1.14,0,0,0,0-.83,43.36,43.36,0,0,0-2-5.6c-.89-1.91-2.06-4.65-4.41-4.74-2.73-.1-5.32,1.11-7.75,2.35a6.64,6.64,0,0,0-3.47,5.91,8.75,8.75,0,0,0,.48,3.48,27.55,27.55,0,0,0,1.79,3Z",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 388.15,
  cy: 214.97,
  r: 0.48,
  style: {
    fill: "#0e1010"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M390,219.46a1.83,1.83,0,0,1-1.82-.92",
  style: {
    fill: "none",
    stroke: "#8b5624",
    strokeMiterlimit: 10,
    strokeWidth: "0.25px"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M382.89,214.56a2.58,2.58,0,0,1,2-2.25c1.09-.31,2.25-.3,3.34-.57a6.67,6.67,0,0,0,2.13-.94,5,5,0,0,0,1.39-1.32,4.4,4.4,0,0,0-.08-5,3.87,3.87,0,0,0-4.34-1.63c-1.79.54-3.11,2-4.63,3.07a11.51,11.51,0,0,1-4.33,1.86c-1.46.3-3,.34-4.3,1.16a5.23,5.23,0,0,0-1.6,1.74,9.78,9.78,0,0,0-1,7.12c.54,2.42,1.94,5.75,4.91,5.71a3.72,3.72,0,0,0,3.15-1.91,5.24,5.24,0,0,1-2.14-1.58,3.17,3.17,0,0,1-.44-2.19,2.93,2.93,0,0,1,.63-1.52,2.36,2.36,0,0,1,3.84.33c.11.19.2.4.4.49a.59.59,0,0,0,.69-.27,1.6,1.6,0,0,0,.18-.78A14,14,0,0,1,382.89,214.56Z",
  style: {
    fill: "#8b5624"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "386.96 225.93 382.69 225.93 385.54 228.46",
  style: {
    fill: "#ebb990",
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("g", {
  style: {
    clipPath: "url(#clip-path-3)"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M359.82,263.05l10.85,34.57L357.1,330.15l9.47,5.87,17.5-32.52a11.38,11.38,0,0,0,1.15-7.57l-2.78-14.18",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "359.56 264.05 384.56 308.25 388.28 290.07",
  style: {
    fill: "#acacac"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M360,258.15s-2.44,9.05,4,15.06l6.46,6,15.93,13.89a14.4,14.4,0,0,1,4.58,7.61l8.51,36.5,12.34,1s-3.41-46.13-4.93-48.12-20.8-32.84-19.73-30.33",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M406.25,253.55l-12.49-3.18,2.63-10.32,9.64,2.46L417.13,225l6.18,3.15-9.44,21.69A6.53,6.53,0,0,1,406.25,253.55Z",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M393.13,252l5.78-12.54-14.22-6.63a7,7,0,0,0-9.92,6.09h0c-.11,2.89,2.94,6.15,5.59,7.29Z",
  style: {
    fill: "#ee8322"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M393.13,252l5.78-12.54-14.22-6.63a7,7,0,0,0-9.92,6.09h0c-.11,2.89,2.94,6.15,5.59,7.29Z",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-23)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M360,258.15l1.86-28c.75-4.34,8-6.52,11.75-4.21l10.51,6.48a15.15,15.15,0,0,1,7.14,14.07l-1.33,17",
  style: {
    fill: "#ee8322"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M400,271.42l-22.77-3.64a7.7,7.7,0,0,1-6.16-5.67l-8.6-33.19,10.3-2.66L381,258l19,6.2Z",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M365.69,247.14l13.58-3.26-3.82-14a7,7,0,0,0-11-3.74h0a7,7,0,0,0-2.44,7.51Z",
  style: {
    fill: "#ee8322"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M365.69,247.14l13.58-3.26-3.82-14a7,7,0,0,0-11-3.74h0a7,7,0,0,0-2.44,7.51Z",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-24)"
  }
}), /*#__PURE__*/React.createElement("path", {
  id: "_Path_",
  "data-name": "<Path>",
  d: "M398.86,264.24a37.48,37.48,0,0,1,6.61-2.22c.54-.1,1.08-.19,1.6-.31.32-.07.89-.38,1.21-.3,1.26.33-.41,1.5-.83,1.84-.69.55-2,1.54-1,2.36,1.2,1,2.77.66,4.15.45,1-.15,3.86-.61,4.19.84.21.88-1,2.23-1.48,2.86-3.07,3.88-8.19,3.19-12.43,2.12-.95-.24-1.9-.41-2.83-.72",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M417,225.77c-.23-1.19-.49-2.38-.78-3.56a8,8,0,0,1-.54-2.72c.54-2.12,2.77,1.81,3.26,2.62.53-2.5,3.17-7,6.22-5.89,4.06,1.49,1.45,7.3-.18,9.67-.93,1.35-1.83,2.85-2.66,4.23",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M407,266.12v7a.63.63,0,0,0,1.25,0v-7a.63.63,0,0,0-1.25,0Z",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M658.6,270.84c1.15-.45,1.79-1.41,2.77-2.13s2.5-.94,3.27-1.91.63-2.52,1.13-3.67,1.71-2.07,1.9-3.32-.69-2.48-.82-3.76.46-2.71,0-3.85-1.83-1.84-2.55-2.83-.91-2.57-1.85-3.35-2.47-.65-3.59-1.16-2-1.76-3.25-2-2.42.71-3.67.84-2.65-.47-3.76,0-1.79,1.88-2.77,2.61c-1.13.84-2.38,1-3.27,2.11a3.57,3.57,0,0,0-.72,3.8c-1.18,1.08-1.91,2.84-1.11,4.2a2.77,2.77,0,0,1,.42.75,2.63,2.63,0,0,1,0,1.08,3.13,3.13,0,0,0,.83,2.46,7.93,7.93,0,0,1,.85.89,7.09,7.09,0,0,1,.39.78,4.09,4.09,0,0,0,3,2.15c.81.13,1.46-.07,2.28,0a4.38,4.38,0,0,1,3.23,1.63c1,1.32,1,3.95,2.44,4.86C654.85,271.8,657.41,271.31,658.6,270.84Z",
  style: {
    fill: "#8b5624"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M688.21,348.69c.21-.18,1.11.38,2,.17h0a1.69,1.69,0,0,0,1.26-2L685.7,322.1,682.42,324",
  style: {
    fill: "#727d79"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M563.69,323.19l3.28-.32-5.79,24.73a1.68,1.68,0,0,1-2,1.26h0c-.9-.21-1.47-1.12-1.26-.93",
  style: {
    fill: "#727d79"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M563,316.38l-9.28-28.6a7,7,0,0,1,6.63-9.12h133.6a7,7,0,0,1,6.79,8.51l-6.6,29.21",
  style: {
    fill: "#ee8322"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M563,316.38l-9.28-28.6a7,7,0,0,1,6.63-9.12h133.6a7,7,0,0,1,6.79,8.51l-6.6,29.21",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-25)"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 547.64,
  y: 314.68,
  width: 157.36,
  height: 9.23,
  rx: 3.08,
  ry: 3.08,
  style: {
    fill: "#ee8322"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M630,289.5l-6.29,11.39a4.51,4.51,0,0,1-7.74.91l-6.15-14.26-1.13-7.37,8.68,3.68,2.47,10.21,5.53-8.34",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "664.12 319.29 667.29 349.93 659.07 349.93 653.25 322.29",
  style: {
    fill: "#c1813e"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M671.79,285l3.56,26.23,6.19,3.18c1.37,1.06-.63,1.6-1.69,1.88H665.61L661.32,286",
  style: {
    fill: "#c1813e"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M636.52,285.91,633,312.14l-6.18,3.18c-1.37,1.06.63,1.6,1.69,1.87h14.24L647,286.91",
  style: {
    fill: "#c1813e"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "642.27 320.35 639.1 350.99 647.32 350.99 653.14 323.35",
  style: {
    fill: "#c1813e"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M647.33,274.82l-1.21-4.41-2.43-.27c-1.9-.37-1.43-2.49-1.24-3.84l.45-3.15c-.4,0-.89,0-1-.38a1,1,0,0,1,.09-.74,38.17,38.17,0,0,1,2.21-4.82,12.6,12.6,0,0,1,3.43-4c1.17-.85,2.47-.42,3.86,0a9.29,9.29,0,0,1,3.68,2.19,8.57,8.57,0,0,1,1.77,2.29,7.89,7.89,0,0,1-1.62,9.42l2.63,6.35",
  style: {
    fill: "#c1813e"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 645.42,
  cy: 260.01,
  r: 0.44,
  style: {
    fill: "#0e1010"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M646.71,263.09l-2.33.6s.46,1.13,1.35,1S646.71,263.09,646.71,263.09Z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "646.12 270.41 649.63 270.71 646.71 272.48",
  style: {
    fill: "#ebb990",
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M658.18,270.14a7.15,7.15,0,0,0,1.75-3.15,17.14,17.14,0,0,0-.47-8.5c-1.08-3.42-4.91-5.12-8.11-6.12-1.26-.4-3.14-1-4.42-.37-2,1-.09,3.44,1.19,4.2a12.7,12.7,0,0,0,3.74,1.26l-.71,5a2.8,2.8,0,0,1,3-.34,2.26,2.26,0,0,1,.85,1.52c.3,1.92-1.09,3-2.51,3.94.67,1.7,1.61,4,3.84,3.64A3.65,3.65,0,0,0,658.18,270.14Z",
  style: {
    fill: "#8b5624"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M673.43,287.22l-8.43.19,2.06,19.11-25.48-.38,2.06-18h-9.36s.63-13.85,18-15C671.66,272,673.43,287.22,673.43,287.22Z",
  style: {
    fill: "#00d38d"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M673.43,287.22l-8.43.19,2.06,19.11-25.48-.38,2.06-18h-9.36s.63-13.85,18-15C671.66,272,673.43,287.22,673.43,287.22Z",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-26)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M669,331.25a3.09,3.09,0,0,0,3-3.51l-3.82-24.12c-.74-4.71-4.87-7-9.64-6.85l-8.64.29a9.45,9.45,0,0,0-8.95,7.65c-1.64,8.58-4.27,17.84-5.3,23.73a2.39,2.39,0,0,0,2.36,2.81Z",
  style: {
    fill: "#f4b01a"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M669,331.25a3.09,3.09,0,0,0,3-3.51l-3.82-24.12c-.74-4.71-4.87-7-9.64-6.85l-8.64.29a9.45,9.45,0,0,0-8.95,7.65c-1.64,8.58-4.27,17.84-5.3,23.73a2.39,2.39,0,0,0,2.36,2.81Z",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-27)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M578.93,285l-3.56,26.23-6.19,3.18c-1.37,1.06.63,1.6,1.69,1.88h8.4a3.37,3.37,0,0,0,3.34-2.9L586.49,286",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M603.31,275.8l1.34-4.52,2.52-.23c2-.34,1.52-2.54,1.35-3.93l-.4-3.26c.41,0,.93,0,1.1-.37a1,1,0,0,0-.08-.77,39.86,39.86,0,0,0-2.18-5,13.14,13.14,0,0,0-3.45-4.2c-1.19-.9-2.54-.48-4-.11a9.35,9.35,0,0,0-3.84,2.19,8.71,8.71,0,0,0-1.88,2.31,8.14,8.14,0,0,0,1.48,9.76l-2.86,6.5",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 605.6,
  cy: 260.57,
  r: 0.45,
  style: {
    fill: "#0e1010"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "604.65 271.28 601.03 271.51 603.99 273.4",
  style: {
    fill: "#ebb990",
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M607.11,264.8a1.82,1.82,0,0,1-1.89-.64",
  style: {
    fill: "none",
    stroke: "#8b5624",
    strokeMiterlimit: 10,
    strokeWidth: "0.25px"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M591.06,268.29c-.26-.35-1.1-1.64-.28-1.82-1.4-.22-2.78-2.21-2.8-3.61a5.2,5.2,0,0,1,4.07-5,4.72,4.72,0,0,1,3.16-5.16,10.48,10.48,0,0,1,4.43-.25c.37,0,.92.43,1.26.38s1.08-.82,1.65-1c1.76-.49,4.14.45,4.1,2.53,0,3-4.32,3.06-6.3,3l-.54,5.15a2.87,2.87,0,0,0-2.94-1.11,2.33,2.33,0,0,0-1.24,1.3c-.78,1.85.32,3.3,1.51,4.58.92,1-2.78,2.13-3.43,2.12A2.82,2.82,0,0,1,591.06,268.29Z",
  style: {
    fill: "#050505"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M577.29,287.73,587.84,289l2.48-8.65a5.27,5.27,0,0,0-5.69-6.69h0a5.26,5.26,0,0,0-4.49,3.93Z",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M577.29,287.73,587.84,289l2.48-8.65a5.27,5.27,0,0,0-5.69-6.69h0a5.26,5.26,0,0,0-4.49,3.93Z",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-28)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M619.26,283.65l-9,5.58-5.91-6.77a5.28,5.28,0,0,1,2.31-8.48h0a5.26,5.26,0,0,1,5.73,1.65Z",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M619.26,283.65l-9,5.58-5.91-6.77a5.28,5.28,0,0,1,2.31-8.48h0a5.26,5.26,0,0,1,5.73,1.65Z",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-29)"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "611.91 305.35 582.73 305.35 586.73 273.71 607.79 273.71 611.91 305.35",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "611.91 305.35 582.73 305.35 586.73 273.71 607.79 273.71 611.91 305.35",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-30)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M582.77,316.26h29.08a2.06,2.06,0,0,0,2.26-2.25c-.25-1.22-.69-3.24-1.45-6.61-.94-4.1-5.1-7.11-10-7.25l-9.69-.28c-5.34-.15-10,3.09-10.81,7.55L581,314.5A1.66,1.66,0,0,0,582.77,316.26Z",
  style: {
    fill: "#006c43"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M584.13,310.5l-2,34.75,8.6-.63L596.07,312a6,6,0,0,0-5.94-7h0A6,6,0,0,0,584.13,310.5Z",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M583.14,343.44a1.33,1.33,0,0,0-1.33.78,19.63,19.63,0,0,1-3.64,4.85c-.72.81-2.71,3.81-.43,4l12.7-.06.94-7.77a1.06,1.06,0,0,0-1-1.26Z",
  style: {
    fill: "#727d79"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M640.91,343.4a1.33,1.33,0,0,0-1.33.78A19.85,19.85,0,0,1,636,349c-.73.81-2.72,3.81-.44,4l12.7-.06.94-7.77a1.06,1.06,0,0,0-1-1.26Z",
  style: {
    fill: "#e65e9b"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M610.29,310.5l2.17,34.75-8.36.5L598.35,312a6,6,0,0,1,5.94-7h0A6,6,0,0,1,610.29,310.5Z",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M603.28,345.05l.77,8.05L617,353c2.28-.21.29-3.22-.44-4a19.06,19.06,0,0,1-3.71-5,.92.92,0,0,0-.93-.62l-7.77.61A.91.91,0,0,0,603.28,345.05Z",
  style: {
    fill: "#727d79"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M657.92,345.05l.77,8.05,12.9-.06c2.28-.21.3-3.22-.43-4a19.09,19.09,0,0,1-3.72-5,.92.92,0,0,0-.93-.62l-7.77.61A.91.91,0,0,0,657.92,345.05Z",
  style: {
    fill: "#e65e9b"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 607.05,
  y1: 292.28,
  x2: 607.42,
  y2: 292.78,
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M625.19,286.66l0-2.6c0-.75-.63-4,.59-3.95,1,.07.8,2,1.34,2.52l1.33-2.17c.41-.66,1-2.39,1.89-2.6,1.5-.37,2.37,2.68,2.67,3.7.52,1.79-.74,3.48-1.49,5.11-.33.71-1.7,2.82-2,3.55",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 652.25,
  cy: 267.28,
  r: 0.61,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 62.64,
  y: 337.22,
  width: 11.61,
  height: 3.6,
  rx: 0.83,
  ry: 0.83,
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M62,327.82l-.92,5.93a2.21,2.21,0,0,0,1.62,2.47l11.14,2.91c2.8.73,4.52-2.7,2-4l-.06,0c-.84-.4-1.77-.62-2.56-1.08-1.87-1.08-2.59-3.14-3.16-5",
  style: {
    fill: "#727d79"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "45.42 275.44 56.84 293.44 60.79 330.33 70.89 330.99 67.54 281.17",
  style: {
    fill: "#acacac"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 51.75,
  y: 278.05,
  width: 2.18,
  height: 13.14,
  transform: "translate(-150.19 78.28) rotate(-34.02)",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 37.49,
  y: 289.56,
  width: 54.29,
  height: 2.18,
  transform: "translate(-2.27 0.51) rotate(-0.45)",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 35.15,
  y: 274.55,
  width: 21.78,
  height: 6.94,
  rx: 1.59,
  ry: 1.59,
  style: {
    fill: "#727d79"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36.66,
  cy: 317.84,
  r: 24.78,
  style: {
    fill: "none",
    stroke: "#0e1010",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114.5,
  cy: 317.01,
  r: 24.78,
  style: {
    fill: "none",
    stroke: "#0e1010",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 27.66,
  y: 287.64,
  width: 2.18,
  height: 30.71,
  transform: "translate(-121.06 38.06) rotate(-24.07)",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.76,290.06H20.21a2.6,2.6,0,0,1,0-5.19H39.76a2.6,2.6,0,1,1,0,5.19Zm-19.55-3a.43.43,0,0,0-.42.42.44.44,0,0,0,.42.42H39.76a.43.43,0,0,0,.42-.42.42.42,0,0,0-.42-.42Z",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.09,317.33,95.93,263.62a5.15,5.15,0,0,0-6.78-3.15L82,264.26l-1-1.93,7.28-3.84A7.32,7.32,0,0,1,98,262.92l18.16,53.72Z",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 78.39,
  y: 261.54,
  width: 7.82,
  height: 3.21,
  rx: 0.52,
  ry: 0.52,
  transform: "translate(-120.54 76.41) rotate(-30)",
  style: {
    fill: "#0e1010"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 56.1,
  y: 299.31,
  width: 57.25,
  height: 2.18,
  transform: "translate(-210.56 199.29) rotate(-55.35)",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 66.64,
  y: 323.93,
  width: 11.61,
  height: 3.6,
  rx: 0.83,
  ry: 0.83,
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114.5,
  cy: 317.01,
  r: 2.54,
  style: {
    fill: "#0e1010"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.54,320.05h-28a2.64,2.64,0,0,1-2.64-2.64v-2.79A2.64,2.64,0,0,1,37.52,312h28a2.64,2.64,0,0,1,2.63,2.64v2.79A2.64,2.64,0,0,1,65.54,320.05Zm-28-7.08a1.65,1.65,0,0,0-1.65,1.65v2.79a1.65,1.65,0,0,0,1.65,1.65h28a1.65,1.65,0,0,0,1.64-1.65v-2.79A1.65,1.65,0,0,0,65.54,313Z",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.23,315.72v6a2.2,2.2,0,0,0,2,2.19l11.46,1.19c2.87.3,4-3.35,1.33-4.21l-.07,0c-.89-.27-1.84-.35-2.7-.68-2-.79-3-2.72-3.88-4.49",
  style: {
    fill: "#727d79"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.41,258.14c-1.81,6.32-.9,12.39,4.15,16.61a22,22,0,0,0,3.66,2.36q7,3.88,14.41,7.06l5.27,33.7,9.68-.05-1.45-33c-.69-5.34,0-5.89-2.32-8.51l-15.42-18.1",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.3,234.44l9.54,1.76s.07,0,.08,0l.46-3.15,2,.33c1.63.12,1.72-1.72,1.87-2.87l.33-2.67c.32.11.73.19.94-.08a.77.77,0,0,0,.09-.62,31.46,31.46,0,0,0-.72-4.43,10.66,10.66,0,0,0-1.92-4c-.76-1-1.92-.9-3.14-.88a7.64,7.64,0,0,0-3.49,1,7.3,7.3,0,0,0-2,1.47,8.15,8.15,0,0,0-1.79,5.31",
  style: {
    fill: "#8b5624"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.07,228.74a1.9,1.9,0,0,1-1.31-1.2l.39-.15a1.54,1.54,0,0,0,1.37,1v.43A1.74,1.74,0,0,1,59.07,228.74Z",
  style: {
    fill: "#8b5624",
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.32,220.75a17.55,17.55,0,0,0-2.21.61,3.41,3.41,0,0,0-1.44,2.37c-.24.83-.18,2.27-1.22,2.52-1.7.4-.9-3.71-3.69-3a2.52,2.52,0,0,0-1.72,2.4,4.77,4.77,0,0,0,1.06,2.91c-.84,1.61-2.07,3.44-3.87,3.35a4.46,4.46,0,0,1-1.29-.33,19.26,19.26,0,0,1-4-2.15c-1.44-1-2.81-2.27-4.54-2.6A9.19,9.19,0,0,0,33,227a31.5,31.5,0,0,1-6.1.75A9.69,9.69,0,0,1,21,226c-1.46-1.11-2.46-2.76-4-3.78-2.14-1.44-5.08-1.5-6.94-3.28-2.19-2.09-1.92-5.84-.23-8.36,2.43-3.61,7.63-5.2,11.5-3.2a28.87,28.87,0,0,1,4.42,3.42,7.45,7.45,0,0,0,5.08,2,15.91,15.91,0,0,0,4-1.35,11,11,0,0,1,10,1.37,35.19,35.19,0,0,0,3.34,2.52c1.88,1,3.28.86,5.33.84a14.43,14.43,0,0,1,3.38.59c1.08.25,2.87.88,3.4,2S60.24,220.47,59.32,220.75Z",
  style: {
    fill: "#0e1010"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M40,239l-3.18,20.67L60,263.54l.29-18.35c0-6.59-2.88-9.27-6.25-11.51-4.93-3.27-12.35-1.24-13.78,4.5C40.14,238.46,40.08,238.75,40,239Z",
  style: {
    fill: "#00d38d"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.46,247.93l7,9.62a6.7,6.7,0,0,0,5.14,2.83l9.71.36,7.46.28a37.76,37.76,0,0,1,5.22.15c1.43.26,2.11,1.66,3.3,2.41,1,.6,2.44,1.22,3.4.28,2.12-2-2.28-5.17-3.73-6.21-2-1.41-4.7-1.54-7-2l-6.73-1.32L61,252.12l-.15,0-4.63-7.9",
  style: {
    fill: "#8b5624"
  }
}), /*#__PURE__*/React.createElement("path", {
  id: "_Path_2",
  "data-name": "<Path>",
  d: "M52.68,235.07l6.07,10.8L47.55,251,42,240.29a5.94,5.94,0,0,1,3.23-7.8h0A5.94,5.94,0,0,1,52.68,235.07Z",
  style: {
    fill: "#00d38d"
  }
}), /*#__PURE__*/React.createElement("path", {
  id: "_Path_3",
  "data-name": "<Path>",
  d: "M52.68,235.07l6.07,10.8L47.55,251,42,240.29a5.94,5.94,0,0,1,3.23-7.8h0A5.94,5.94,0,0,1,52.68,235.07Z",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-31)"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58.66,
  cy: 224.67,
  r: 0.29,
  style: {
    fill: "#0e1010"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35.38,
  cy: 318.64,
  r: 2.54,
  style: {
    fill: "#0e1010"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "56.45 233.06 54.26 232.62 56.23 234.38",
  style: {
    fill: "#8b5624"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M143.75,100.28l-88-.33c2.43-1.71,3.62-3.58,6.66-4.42,2.79-.76,5.81-.47,8.34-2.22,3.27-2.25,5.06-6.48,8.4-8.79C83.8,81.31,89.73,80.19,94.76,83c3.4,1.92,5.71,5.51,9.25,7.2,3.76,1.8,6.36.18,10-.7,7.64-1.86,9.22,3.83,15.57,5.42,3.17.8,5.55-.86,8.72.66,1.94.94,4.62,2.54,5.46,4.67",
  style: {
    fill: "#edf1f0"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M383.75,119.17l-88-.34c2.43-1.7,3.62-3.58,6.66-4.41,2.79-.77,5.81-.48,8.34-2.22,3.27-2.26,5.06-6.48,8.4-8.79,4.65-3.22,10.58-4.34,15.61-1.5,3.4,1.92,5.71,5.51,9.25,7.21,3.76,1.8,6.36.17,10-.71,7.64-1.86,9.22,3.84,15.57,5.43,3.17.79,5.55-.86,8.72.66,1.94.93,4.62,2.53,5.46,4.67",
  style: {
    fill: "#edf1f0"
  }
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuilding);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/building.8beb07ea5be70332d29a812c18efd2d6.svg";